module.exports = __webpack_public_path__ + "img/img2.2a6000c0.jpg";